// Copyright (c) 2015, Frappe Technologies Pvt. Ltd. and Contributors
// MIT License. See license.txt

frappe.provide("frappe.treeview_settings");
frappe.provide("frappe.views.trees");
window.cur_tree = null;

frappe.views.TreeFactory = class TreeFactory extends frappe.views.Factory {
	make(route) {
		frappe.model.with_doctype(route[1], function () {
			var options = {
				doctype: route[1],
				meta: frappe.get_meta(route[1]),
			};

			if (
				!frappe.treeview_settings[route[1]] &&
				!frappe.meta.get_docfield(route[1], "is_group")
			) {
				frappe.msgprint(__("Tree view is not available for {0}", [__(route[1])])); // @dokos
				return false;
			}
			$.extend(options, frappe.treeview_settings[route[1]] || {});
			frappe.views.trees[options.doctype] = new frappe.views.TreeView(options);
		});
	}

	on_show() {
		/**
		 * On back-navigation the framework re-shows the existing treeview
		 * element instead of rebuilding it, so the expanded nodes are kept
		 * as the user left them. Point cur_tree back at this tree; use the
		 * Refresh menu item to reload data when it may have changed.
		 */
		let route = frappe.get_route();
		let treeview = frappe.views.trees[route[1]];
		if (treeview && treeview.tree) {
			cur_tree = treeview.tree;
			if (treeview.scroll_position) {
				frappe.utils.scroll_to(treeview.scroll_position, false, 0, $(".main-section"));
			}
		}
	}

	get view_name() {
		return "Tree";
	}
};

frappe.views.TreeView = class TreeView {
	constructor(opts) {
		var me = this;

		this.opts = {};
		this.opts.get_tree_root = true;
		this.opts.show_expand_all = true;
		$.extend(this.opts, opts);
		this.doctype = opts.doctype;
		this.args = { doctype: me.doctype };
		this.page_name = frappe.get_route_str();
		this.get_tree_nodes = me.opts.get_tree_nodes || "frappe.desk.treeview.get_children";

		this.get_permissions();

		this.make_page();
		this.make_filters();
		this.root_value = null;
		if (me.opts.get_tree_root) {
			this.get_root();
		}

		this.onload();

		if (!this.opts.do_not_setup_menu) {
			this.set_menu_item();
		}

		this.set_primary_action();
	}
	get_permissions() {
		this.can_read = frappe.model.can_read(this.doctype);
		this.can_create =
			frappe.boot.user.can_create.indexOf(this.doctype) !== -1 ||
			frappe.boot.user.in_create.indexOf(this.doctype) !== -1;
		this.can_write = frappe.model.can_write(this.doctype);
		this.can_delete = frappe.model.can_delete(this.doctype);
	}
	make_page() {
		var me = this;
		if (!this.opts || !this.opts.do_not_make_page) {
			this.parent = frappe.container.add_page(this.page_name);
			$(this.parent).addClass("treeview");
			$(".main-section").on("scroll.treeview_" + this.page_name, () => {
				if (frappe.get_route_str() === me.page_name) {
					me.scroll_position = $(".main-section").scrollTop();
				}
			});
			frappe.ui.make_app_page({ parent: this.parent, single_column: true });
			this.page = this.parent.page;
			frappe.container.change_to(this.page_name);
			frappe.breadcrumbs.add(
				me.opts.breadcrumb || locals.DocType[me.doctype].module,
				me.doctype
			);

			this.set_title();

			this.page.main.css({
				"min-height": "300px",
			});

			this.page.main.addClass("frappe-card");
		} else {
			this.page = this.opts.page;
			$(this.page[0]).addClass("frappe-card");
		}

		if (frappe.meta.has_field(me.doctype, "disabled")) {
			this.page.add_inner_button(
				__("Include Disabled"),
				function () {
					me.toggle_disable(event.target);
					me.make_tree();
				},
				__("Expand"),
				"default",
				true
			);
		}

		if (this.opts.show_expand_all) {
			this.$collapse_all_btn = this.page
				.add_menu_item(__("Collapse All"), function () {
					me.tree.load_children(me.tree.root_node, false);
				})
				.parent();

			this.$expand_all_btn = this.page
				.add_menu_item(__("Expand All"), function () {
					me.tree.load_children(me.tree.root_node, true);
				})
				.parent();
		}

		if (this.opts.view_template) {
			var row = $('<div class="row"><div>').appendTo(this.page.main);
			this.body = $('<div class="col-sm-6 col-xs-12"></div>').appendTo(row);
			this.node_view = $('<div class="col-sm-6 hidden-xs"></div>').appendTo(row);
		} else {
			this.body = this.page.main;
		}
	}
	set_title() {
		// @dokos: __("Tree")
		this.page.set_title(this.opts.title || __("{0} Tree", [__(this.doctype)]));
	}
	onload() {
		var me = this;
		this.opts.onload && this.opts.onload(me);
	}
	make_filters() {
		var me = this;
		frappe.treeview_settings.filters = [];
		$.each(this.opts.filters || [], function (i, filter) {
			if (frappe.route_options && frappe.route_options[filter.fieldname]) {
				filter.default = frappe.route_options[filter.fieldname];
			}

			if (!filter.disable_onchange) {
				filter.change = function () {
					filter.onchange && filter.onchange();
					var val = this.get_value();
					me.args[filter.fieldname] = val;
					if (val) {
						me.root_label = val;
					} else {
						me.root_label = me.opts.root_label;
					}
					me.set_title();
					me.make_tree();
				};
			}

			if (filter.render_on_toolbar) {
				me.page.add_field(filter, me.page.filters);
			} else {
				me.page.add_field(filter);
			}

			if (filter.default) {
				$("[data-fieldname='" + filter.fieldname + "']").trigger("change");
			}
		});
	}
	get_root() {
		var me = this;

		frappe.call({
			method: me.get_tree_nodes,
			args: me.args,
			callback: function (r) {
				if (r.message) {
					if (r.message.length == 1) {
						me.root_label = r.message[0]["value"];
						me.root_value = me.root_label;
					} else {
						me.root_label = me.doctype;
						me.root_value = "";
					}

					me.make_tree();
				}
			},
		});
	}
	toggle_disable(el) {
		if (this.args["include_disabled"]) {
			this.args["include_disabled"] = false;
			el.innerText = el.innerText.replace("Exclude", "Include");
		} else {
			this.args["include_disabled"] = true;
			console.log(el);
			el.innerText = el.innerText.replace("Include", "Exclude");
		}
	}
	make_tree() {
		$(this.parent).find(".tree").remove();
		this.before_render(); // @dokos

		var use_label = this.args[this.opts.root_label] || this.root_label || this.opts.root_label;
		var use_value = this.root_value;
		if (use_value == null) {
			use_value = use_label;
		}

		this.tree = new frappe.ui.Tree({
			parent: this.body,
			label: use_label,
			root_value: use_value,
			expandable: true,

			args: this.args,
			method: this.get_tree_nodes,

			// array of button props: {label, condition, click, btnClass}
			toolbar: this.get_toolbar(),

			get_label: this.opts.get_label,
			on_render: this.opts.onrender,
			on_get_node: this.opts.on_get_node,
			on_node_render: (node, deep) => {
				this.opts.on_node_render && this.opts.on_node_render(node, deep);
				this.update_expand_collapse_buttons();
			},
			on_click: (node) => {
				this.select_node(node);
				// node.expanded is flipped synchronously right after this callback
				// runs, so defer the state check to the next tick
				setTimeout(() => this.update_expand_collapse_buttons(), 0);
			},
			// @dokos: reparent a node via drag-and-drop
			on_drop: this.can_write ? (node, target) => this.move_node(node, target) : null,
		});

		cur_tree = this.tree;
		cur_tree.view_name = "Tree";
		this.post_render();
	}

	// @dokos: reparent a dragged node into a target group
	// call site: the `on_drop` handler above — upstream has no drag-and-drop,
	// so a port that rewrites make_tree() must keep this method alive.
	move_node(node, target) {
		const parentField =
			"parent_" + this.doctype.toLowerCase().replace(/ /g, "_").replace(/-/g, "_");
		frappe.db
			.set_value(this.doctype, node.label, parentField, target.label)
			.then(() => this.make_tree());
	}

	// @dokos: remember Tree as the doctype's last view so the list-view switcher
	// comes back to it. Called unconditionally from make_tree() — dropping it
	// breaks every tree view with `this.before_render is not a function`.
	before_render() {
		frappe.model.user_settings.save(this.doctype, "last_view", "Tree");
	}

	get_expandable_nodes() {
		return Object.values(this.tree.nodes).filter(
			(node) =>
				node.expandable && !node.is_root && document.body.contains(node.$tree_link[0])
		);
	}
	update_expand_collapse_buttons() {
		if (!this.opts.show_expand_all || !this.tree) return;

		if (!this.tree.root_node.expanded) {
			// root collapsed hides every descendant, so their stale expanded
			// flags (from before the root was closed) don't reflect what's
			// actually visible; only offer to expand back out
			this.$collapse_all_btn && this.$collapse_all_btn.hide();
			this.$expand_all_btn && this.$expand_all_btn.show();
			return;
		}

		let expandable_nodes = this.get_expandable_nodes();
		let has_expandable_nodes = expandable_nodes.length > 0;
		let all_expanded = has_expandable_nodes && expandable_nodes.every((node) => node.expanded);
		let all_collapsed =
			has_expandable_nodes && expandable_nodes.every((node) => !node.expanded);

		this.$collapse_all_btn &&
			this.$collapse_all_btn.toggle(has_expandable_nodes && !all_collapsed);
		this.$expand_all_btn && this.$expand_all_btn.toggle(has_expandable_nodes && !all_expanded);
	}
	toggle_label() {
		//
	}
	rebuild_tree() {
		let me = this;
		frappe.call({
			method: "frappe.utils.nestedset.rebuild_tree_for_doctype",
			args: {
				doctype: me.doctype,
			},
			callback: function (r) {
				if (!r.exc) {
					me.make_tree();
				}
			},
		});
	}

	post_render() {
		var me = this;
		me.opts.post_render && me.opts.post_render(me);
	}

	select_node(node) {
		var me = this;
		if (this.opts.click) {
			this.opts.click(node);
		}
		if (this.opts.view_template) {
			this.node_view.empty();
			$(
				frappe.render_template(me.opts.view_template, {
					data: node.data,
					doctype: me.doctype,
				})
			).appendTo(this.node_view);
		}
	}
	get_toolbar() {
		var me = this;

		var toolbar = [
			{
				label: __(me.can_write ? "Edit" : "Details"),
				condition: function (node) {
					return !node.is_root && me.can_read;
				},
				click: function (node) {
					frappe.set_route("Form", me.doctype, node.label);
				},
			},
			{
				label: __("Add Child"),
				condition: function (node) {
					return me.can_create && node.expandable && !node.hide_add;
				},
				click: function (node) {
					me.new_node();
				},
				btnClass: "hidden-xs",
			},
			{
				label: __("Rename"),
				condition: function (node) {
					let allow_rename = true;
					if (me.doctype && frappe.get_meta(me.doctype)) {
						if (!frappe.get_meta(me.doctype).allow_rename) allow_rename = false;
					}
					return !node.is_root && me.can_write && allow_rename;
				},
				click: function (node) {
					frappe.model.rename_doc(me.doctype, node.label, function (new_name) {
						node.$tree_link.find("a").text(new_name);
						node.label = new_name;
						me.tree.refresh();
					});
				},
				btnClass: "hidden-xs",
			},
			{
				label: __("Delete"),
				condition: function (node) {
					return !node.is_root && me.can_delete;
				},
				click: function (node) {
					frappe.model.delete_doc(me.doctype, node.label, function () {
						node.parent.remove();
					});
				},
				btnClass: "hidden-xs",
			},
			// @dokos: convert leaf → group
			{
				label: __("Convert to Group"),
				condition: function (node) {
					return !node.is_root && !node.expandable && me.can_write;
				},
				click: function (node) {
					frappe.db
						.set_value(me.doctype, node.label, "is_group", 1)
						.then(() => me.make_tree());
				},
				btnClass: "hidden-xs",
			},
			// @dokos: convert group → leaf (only when expanded and has no children)
			{
				label: __("Convert to Leaf"),
				condition: function (node) {
					return (
						!node.is_root &&
						node.expandable &&
						me.can_write &&
						node.loaded &&
						node.$ul.children().length === 0
					);
				},
				click: function (node) {
					frappe.db
						.set_value(me.doctype, node.label, "is_group", 0)
						.then(() => me.make_tree());
				},
				btnClass: "hidden-xs",
			},
		];

		if (this.opts.toolbar && this.opts.extend_toolbar) {
			toolbar = toolbar.filter((btn) => {
				return !me.opts.toolbar.find((d) => d["label"] == btn["label"]);
			});
			return toolbar.concat(this.opts.toolbar);
		} else if (this.opts.toolbar && !this.opts.extend_toolbar) {
			return this.opts.toolbar;
		} else {
			return toolbar;
		}
	}
	new_node() {
		var me = this;
		var node = me.tree.get_selected_node();

		if (!(node && node.expandable)) {
			frappe.msgprint(__("Select a group {0} first.", [__(me.doctype)]));
			return;
		}

		this.prepare_fields();

		// the dialog
		var d = new frappe.ui.Dialog({
			title: __("New {0}", [__(me.doctype)], me.doctype), // @dokos
			fields: me.fields,
		});

		var args = $.extend({}, me.args);
		args["parent_" + me.doctype.toLowerCase().replace(/ /g, "_").replace(/-/g, "_")] =
			me.args["parent"];

		d.set_value("is_group", 0);
		d.set_values(args);

		// create
		d.set_primary_action(__("Create New"), function () {
			var btn = this;
			var v = d.get_values();
			if (!v) return;

			v.parent = node.label;
			v.doctype = me.doctype;

			if (node.is_root) {
				v["is_root"] = node.is_root;
			} else {
				v["is_root"] = false;
			}

			d.hide();
			frappe.dom.freeze(__("Creating {0}", [me.doctype]));

			$.extend(args, v);
			return frappe.call({
				method: me.opts.add_tree_node || "frappe.desk.treeview.add_node",
				args: args,
				callback: function (r) {
					if (!r.exc) {
						me.tree.load_children(node);
					}
				},
				always: function () {
					frappe.dom.unfreeze();
				},
			});
		});
		d.show();
	}
	prepare_fields() {
		var me = this;

		this.fields = [
			{
				fieldtype: "Check",
				fieldname: "is_group",
				label: __("Is Group"),
				description: __(
					"Further sub-groups can only be created under records marked as 'Group'"
				),
			},
		];

		if (this.opts.fields) {
			this.fields = this.opts.fields;
		}

		this.ignore_fields = this.opts.ignore_fields || [];

		var mandatory_fields = $.map(me.opts.meta.fields, function (d) {
			return d.reqd || (d.bold && !d.read_only && !!d.is_virtual) ? d : null;
		});

		var opts_field_names = this.fields.map(function (d) {
			return d.fieldname;
		});

		mandatory_fields.map(function (d) {
			if (
				$.inArray(d.fieldname, me.ignore_fields) === -1 &&
				$.inArray(d.fieldname, opts_field_names) === -1
			) {
				me.fields.push(d);
			}
		});
	}
	print_tree() {
		if (!frappe.model.can_print(this.doctype)) {
			frappe.msgprint(__("You are not allowed to print this report"));
			return false;
		}
		var tree = $(".tree:visible").html();
		var me = this;
		frappe.ui.get_print_settings(false, function (print_settings) {
			var title = __(me.docname || me.doctype);
			frappe.render_tree({ title: title, tree: tree, print_settings: print_settings });
			frappe.call({
				method: "frappe.core.doctype.access_log.access_log.make_access_log",
				args: {
					doctype: me.doctype,
					report_name: me.page_name,
					page: tree,
					method: "Print",
				},
			});
		});
	}
	set_primary_action() {
		var me = this;
		if (!this.opts.disable_add_node && this.can_create) {
			me.page.set_primary_action(
				__("New"),
				function () {
					me.new_node();
				},
				"plus"
			);
		}
	}
	set_menu_item() {
		var me = this;

		this.menu_items = [
			{
				label: __("View List"),
				action: function () {
					frappe.set_route(["List", me.doctype, "List"]);
				},
			},
			{
				label: __("Print"),
				action: function () {
					me.print_tree();
				},
			},
			{
				label: __("Refresh"),
				action: function () {
					me.make_tree();
				},
			},
		];

		if (
			frappe.user.has_role("System Manager") &&
			frappe.meta.has_field(me.doctype, "lft") &&
			frappe.meta.has_field(me.doctype, "rgt")
		) {
			this.menu_items.push({
				label: __("Rebuild Tree"),
				action: function () {
					me.rebuild_tree();
				},
			});
		}

		if (me.opts.menu_items) {
			me.menu_items.push.apply(me.menu_items, me.opts.menu_items);
		}

		$.each(me.menu_items, function (i, menu_item) {
			var has_perm = true;
			if (menu_item["condition"]) {
				has_perm = eval(menu_item["condition"]);
			}

			if (has_perm) {
				me.page.add_menu_item(menu_item["label"], menu_item["action"]);
			}
		});
	}
};
